<template>
    <a class="link" :href="url" target="_blank">
        <div class="icon"><img :src="icon" /></div>
        <div class="title">{{ title }}</div>
    </a>
</template>

<script>
export default {
    name: 'Link',
    props: ['url', 'icon', 'title']
}
</script>

<style scoped 
       lang="scss">
    @import "../../static/styles/palette.scss";

    .link {
        display: flex;
        margin: 5px 20px;
        text-decoration: none;
        color: $lightGray;

        & .icon {
            margin-right: 8px;
        }
    }

    .link:hover {
        color: $blue;

        & .icon {
            fill: $blue;
        }
    }

    @media all and (max-width: 760px) {
        .link {
            margin: 5px 10px;
        }
    }
</style>


// WEBPACK FOOTER //
// Link.vue?087bb722